import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Logo.png")